// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App Styling */

.app {
  min-height: 100vh;
  /* padding-top: 120px; */
  /* padding-top:90px; */
  /* background-color: #f7f7f6; */
  position: relative;
  padding-bottom: 28rem;
}

.App-header {
  /* min-height: 100vh; */
  display: flex;
  flex-direction: column;
  font-size: calc(8px + 2vmin);
  color: rgb(0, 0, 0);
}

/* #content-wrapper {
  
} */

.homePageBackground {
  padding: 10%;
}

.App-link {
  color: #61dafb;
}

/* site styling */

.site-wrapper {
  flex: 1 1;
}

/* NavTab styling */

.logo img {
  width: 100%;
  max-width: 110px;
  height: 100%;
  max-height: 250px;
}

.logo a{
  text-decoration: none;
  color: black;
}

.nav-bar {
  background-color: white;
  /* background-color: #f7f7f6; */
  border-bottom: 1px solid #787878;
  /* position: sticky;
  top: 0;
  z-index: 100; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sticky {
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
}

.top-row {
  padding-left: 5%;
  padding-right: 5%;
  font-size: calc(1px + 2vmin);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(92, 209, 255, 0.9);
  width: 100%;
}

.nav-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  align-items: center;
}

.nav-button {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 24px;
  cursor: pointer;
}

.nav-button:hover {
  background-color: #0056b3;
}

.contact-link {
  margin-right: 20px;
  color: black;
  text-decoration: none;
}

.contact-link:hover {
  text-decoration: underline;
  color: white;
}

.nav-list ul {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.nav-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.nav-title {
  cursor: pointer;
  margin: 0;
  padding: 0px 16px;
}

.nav-list li {
  cursor: pointer;
  display: flex;
}

.nav-list li.active {
  font-weight: bold;
  background-color: #14161b;
}

.nav-list li:hover {
  background-color: #ababab;
}

.nav-list a {
  text-decoration: none;
  color: black;
  

  display: block;
  width: 100%;
  height: 100%;
  flex: 1 1;
  padding: 8px 32px;
}

.nav-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/* Main body of content styling */

.content-wrapper {
  display: flex;
}

.column-left,
.column-right {
  flex: 1 1;
}

.content {
  margin-top: 0px;
  text-align: center;
  padding-top: 130px;
  /* padding-top: 80px; */
}

.content h1 {
  padding-bottom: 2%;
}

/* HomePage Content Styilng */

#home {
  padding-top: 0;
}

.homePageContent {
  padding: 10px;
  border-radius: 8px;
  color: white;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.homepageBackgroundImage {
  width: 100%;
  height: auto;
  /* background-image: fixed; */
  background-position: center;
}

.purchase-button-homepage {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 24px;
  cursor: pointer;
  margin-top: 15px;
}

.purchase-button-homepage:hover {
  background-color: #0056b3;
}

/* Story page styling */

.storyPage {
  padding-left: 20%;
  padding-right: 20%;
}

.storyPage hr {
  width: 75%;
  margin: 0 auto;
  padding-top: 2%;
}

.storyPage h3 {
  padding-bottom: 2%;
}

/* Contact Content Styling */

.contactPage {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

.contactPage input {
  width: 100%;
}

.contactPage textarea {
  width: 100%;
}

.contactPage button {
  width: 100%;
  max-width: 750px;
  height: 100%;
  max-height: 250px;
  font-size: 24px;
}

/* About Section Styling */

.team-profile-list {
  display: flex;
  gap: 30px;
  padding-left: 20%;
  padding-right: 20%;
}

.team-profile {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.profession {
  color: rgba(0, 159, 222, 1);
}

.about-page ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.team-profile-thumbnail {
  width: 125px;
  max-width: 125px;
  height: 125px;
  max-height: 125px;
  object-fit: cover;
  border-radius: 50%;
  margin: 0 auto;
}

/* Services Page Styling */

.services-page {
  display: flex;
  gap: 15px;
  padding-left: 10%;
  padding-right: 10%;
}

.services-page hr {
  width: 75%;
  margin: 0 auto;
  padding-top: 2%;
}

#services-hr {
  width: 75%;
  margin: 0 auto;
  padding-top: 5%;
}

.card {
  background: rgba(0, 149, 20, 0.9);
  /* background: rgb(96, 101, 255); */
  /* background: rgb(192, 192, 192); */
  /* background: rgb(204, 37, 37); */
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  color: white;
}

.card-thumbnail {
  width: 125px;
  max-width: 125px;
  height: 125px;
  max-height: 125px;
  object-fit: cover;
  border-radius: 50%;
  margin: 0 auto;
}

.card-content {
  margin-top: 10px;
}

.price-tag {
  /* color: #fff; */
  /* color: rgb(202, 204, 255); */
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 28px;
}

.purchase-button {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 15px;
}

.purchase-button:hover {
  background-color: #0056b3;
}

/* .services-page {
  margin: auto;
} */

.services-page-notice ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

/* Slideshow Page Styling */

.slideShow {
  /* background-color: rgba(92, 209, 255, 1); */
  padding-top: 2%;
  padding-bottom: 2%;
}

.slideshow-image {
  width: 100%;
  max-width: 550px;
  height: 100%;
  max-height: 550px;
  object-fit: cover;
  /* border-radius: 50%; */
  margin: 0 auto;
  background-position: center;
}

/* BookNow Page Styling */

.bookNowPage {
  padding-top: 160px;
}

/* Footer styling */

.footer {
  font-size: 20px;
  padding: 10px;
  text-align: center;
  background: rgba(92, 209, 255, 1);
  width: 100%;
  position: absolute;
  bottom: 0;
  width: 100%;
  /* height: 30rem; */
}

.footer a {
  text-decoration: none;
}

.footer a:hover {
  text-decoration: underline;
  color: white;
}

.signature {
  font-size: 14px;
  padding: 10px;
  width: 100%;
}

.signature a {
  text-decoration: none;
  color: white;
}

.signature a:hover {
  text-decoration: underline;
  color: rgb(142, 142, 255);
}

/* Popup Styling */

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Adjust opacity as needed */
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
}

/* Making Site Responsive */

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@media (max-width: 768px) {
  .nav-list li {
    margin-right: 5px;
    margin-bottom: 5px;
    font-size: 14px;
  }
  .contactPage {
    width: 300px;
    justify-content: center;
    flex-wrap: wrap;
  }
  .homePageImage {
    width: 300px;
  }
  .card, .card-content h3, .price-tag {
    font-size: 10px;
  }
  .purchase-button {
    font-size: 10px;
    padding: 0;
  }
  .card-thumbnail {
    width: 50px;
    max-width: 50px;
    height: 50px;
    max-height: 50px;
  }
  .team-profile-list {
    font-size: 10px;
    gap: 15px;
    padding-left: 10%;
    padding-right: 10%;
  }
  .team-profile-thumbnail {
    width: 25px;
    max-width: 25px;
    height: 25px;
    max-height: 25px;
  }
  .slideshow-image {
    width: 100%;
    max-width: 250px;
    height: 100%;
    max-height: 275px;
    object-fit: cover;
    /* border-radius: 50%; */
    margin: 0 auto;
    background-position: center;
  }
  .bookNowPage button{
    width: 50%;
  }
  /* .popup {
    max-width: fit-content;
  } */
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;;AAEjB;EACE,SAAO;AACT;;AAEA,mBAAmB;;AAEnB;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,gCAAgC;EAChC;;iBAEe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,YAAY;;;EAGZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;AACf;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;;AAE7B;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;;AAEvB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;;AAE5B;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,kCAAkC;EAClC,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA,2BAA2B;;AAE3B;EACE,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,2BAA2B;AAC7B;;AAEA,yBAAyB;;AAEzB;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;;AAEnB;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,kBAAkB;;AAElB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,6BAA6B;EACnE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA,2BAA2B;;AAE3B;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,YAAY;IACZ,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,UAAU;EACZ;EACA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;IACd,2BAA2B;EAC7B;EACA;IACE,UAAU;EACZ;EACA;;KAEG;AACL","sourcesContent":["/* App Styling */\n\n.app {\n  min-height: 100vh;\n  /* padding-top: 120px; */\n  /* padding-top:90px; */\n  /* background-color: #f7f7f6; */\n  position: relative;\n  padding-bottom: 28rem;\n}\n\n.App-header {\n  /* min-height: 100vh; */\n  display: flex;\n  flex-direction: column;\n  font-size: calc(8px + 2vmin);\n  color: rgb(0, 0, 0);\n}\n\n/* #content-wrapper {\n  \n} */\n\n.homePageBackground {\n  padding: 10%;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n/* site styling */\n\n.site-wrapper {\n  flex: 1;\n}\n\n/* NavTab styling */\n\n.logo img {\n  width: 100%;\n  max-width: 110px;\n  height: 100%;\n  max-height: 250px;\n}\n\n.logo a{\n  text-decoration: none;\n  color: black;\n}\n\n.nav-bar {\n  background-color: white;\n  /* background-color: #f7f7f6; */\n  border-bottom: 1px solid #787878;\n  /* position: sticky;\n  top: 0;\n  z-index: 100; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.sticky {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  width: 100%;\n}\n\n.top-row {\n  padding-left: 5%;\n  padding-right: 5%;\n  font-size: calc(1px + 2vmin);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgba(92, 209, 255, 0.9);\n  width: 100%;\n}\n\n.nav-buttons {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n  align-items: center;\n}\n\n.nav-button {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 24px;\n  cursor: pointer;\n}\n\n.nav-button:hover {\n  background-color: #0056b3;\n}\n\n.contact-link {\n  margin-right: 20px;\n  color: black;\n  text-decoration: none;\n}\n\n.contact-link:hover {\n  text-decoration: underline;\n  color: white;\n}\n\n.nav-list ul {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.nav-list {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.nav-title {\n  cursor: pointer;\n  margin: 0;\n  padding: 0px 16px;\n}\n\n.nav-list li {\n  cursor: pointer;\n  display: flex;\n}\n\n.nav-list li.active {\n  font-weight: bold;\n  background-color: #14161b;\n}\n\n.nav-list li:hover {\n  background-color: #ababab;\n}\n\n.nav-list a {\n  text-decoration: none;\n  color: black;\n  \n\n  display: block;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  padding: 8px 32px;\n}\n\n.nav-header {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n/* Main body of content styling */\n\n.content-wrapper {\n  display: flex;\n}\n\n.column-left,\n.column-right {\n  flex: 1;\n}\n\n.content {\n  margin-top: 0px;\n  text-align: center;\n  padding-top: 130px;\n  /* padding-top: 80px; */\n}\n\n.content h1 {\n  padding-bottom: 2%;\n}\n\n/* HomePage Content Styilng */\n\n#home {\n  padding-top: 0;\n}\n\n.homePageContent {\n  padding: 10px;\n  border-radius: 8px;\n  color: white;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.homepageBackgroundImage {\n  width: 100%;\n  height: auto;\n  /* background-image: fixed; */\n  background-position: center;\n}\n\n.purchase-button-homepage {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 12px 24px;\n  font-size: 24px;\n  cursor: pointer;\n  margin-top: 15px;\n}\n\n.purchase-button-homepage:hover {\n  background-color: #0056b3;\n}\n\n/* Story page styling */\n\n.storyPage {\n  padding-left: 20%;\n  padding-right: 20%;\n}\n\n.storyPage hr {\n  width: 75%;\n  margin: 0 auto;\n  padding-top: 2%;\n}\n\n.storyPage h3 {\n  padding-bottom: 2%;\n}\n\n/* Contact Content Styling */\n\n.contactPage {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 40%;\n}\n\n.contactPage input {\n  width: 100%;\n}\n\n.contactPage textarea {\n  width: 100%;\n}\n\n.contactPage button {\n  width: 100%;\n  max-width: 750px;\n  height: 100%;\n  max-height: 250px;\n  font-size: 24px;\n}\n\n/* About Section Styling */\n\n.team-profile-list {\n  display: flex;\n  gap: 30px;\n  padding-left: 20%;\n  padding-right: 20%;\n}\n\n.team-profile {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 100%;\n}\n\n.profession {\n  color: rgba(0, 159, 222, 1);\n}\n\n.about-page ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.team-profile-thumbnail {\n  width: 125px;\n  max-width: 125px;\n  height: 125px;\n  max-height: 125px;\n  object-fit: cover;\n  border-radius: 50%;\n  margin: 0 auto;\n}\n\n/* Services Page Styling */\n\n.services-page {\n  display: flex;\n  gap: 15px;\n  padding-left: 10%;\n  padding-right: 10%;\n}\n\n.services-page hr {\n  width: 75%;\n  margin: 0 auto;\n  padding-top: 2%;\n}\n\n#services-hr {\n  width: 75%;\n  margin: 0 auto;\n  padding-top: 5%;\n}\n\n.card {\n  background: rgba(0, 149, 20, 0.9);\n  /* background: rgb(96, 101, 255); */\n  /* background: rgb(192, 192, 192); */\n  /* background: rgb(204, 37, 37); */\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 10px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  color: white;\n}\n\n.card-thumbnail {\n  width: 125px;\n  max-width: 125px;\n  height: 125px;\n  max-height: 125px;\n  object-fit: cover;\n  border-radius: 50%;\n  margin: 0 auto;\n}\n\n.card-content {\n  margin-top: 10px;\n}\n\n.price-tag {\n  /* color: #fff; */\n  /* color: rgb(202, 204, 255); */\n  border: none;\n  border-radius: 4px;\n  padding: 4px 8px;\n  font-size: 28px;\n}\n\n.purchase-button {\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  padding: 12px 24px;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 15px;\n}\n\n.purchase-button:hover {\n  background-color: #0056b3;\n}\n\n/* .services-page {\n  margin: auto;\n} */\n\n.services-page-notice ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Slideshow Page Styling */\n\n.slideShow {\n  /* background-color: rgba(92, 209, 255, 1); */\n  padding-top: 2%;\n  padding-bottom: 2%;\n}\n\n.slideshow-image {\n  width: 100%;\n  max-width: 550px;\n  height: 100%;\n  max-height: 550px;\n  object-fit: cover;\n  /* border-radius: 50%; */\n  margin: 0 auto;\n  background-position: center;\n}\n\n/* BookNow Page Styling */\n\n.bookNowPage {\n  padding-top: 160px;\n}\n\n/* Footer styling */\n\n.footer {\n  font-size: 20px;\n  padding: 10px;\n  text-align: center;\n  background: rgba(92, 209, 255, 1);\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  /* height: 30rem; */\n}\n\n.footer a {\n  text-decoration: none;\n}\n\n.footer a:hover {\n  text-decoration: underline;\n  color: white;\n}\n\n.signature {\n  font-size: 14px;\n  padding: 10px;\n  width: 100%;\n}\n\n.signature a {\n  text-decoration: none;\n  color: white;\n}\n\n.signature a:hover {\n  text-decoration: underline;\n  color: rgb(142, 142, 255);\n}\n\n/* Popup Styling */\n\n.popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5); /* Adjust opacity as needed */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.popup-content {\n  background-color: white;\n  padding: 20px;\n  border-radius: 5px;\n}\n\n/* Making Site Responsive */\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n@media (max-width: 768px) {\n  .nav-list li {\n    margin-right: 5px;\n    margin-bottom: 5px;\n    font-size: 14px;\n  }\n  .contactPage {\n    width: 300px;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n  .homePageImage {\n    width: 300px;\n  }\n  .card, .card-content h3, .price-tag {\n    font-size: 10px;\n  }\n  .purchase-button {\n    font-size: 10px;\n    padding: 0;\n  }\n  .card-thumbnail {\n    width: 50px;\n    max-width: 50px;\n    height: 50px;\n    max-height: 50px;\n  }\n  .team-profile-list {\n    font-size: 10px;\n    gap: 15px;\n    padding-left: 10%;\n    padding-right: 10%;\n  }\n  .team-profile-thumbnail {\n    width: 25px;\n    max-width: 25px;\n    height: 25px;\n    max-height: 25px;\n  }\n  .slideshow-image {\n    width: 100%;\n    max-width: 250px;\n    height: 100%;\n    max-height: 275px;\n    object-fit: cover;\n    /* border-radius: 50%; */\n    margin: 0 auto;\n    background-position: center;\n  }\n  .bookNowPage button{\n    width: 50%;\n  }\n  /* .popup {\n    max-width: fit-content;\n  } */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
